import type { DesignTokens } from "../types/theme";

const WEB_SYSTEM_FONT =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

/**
 * Base tokens for Light mode.
 */
export const LIGHT_BASE_TOKENS: DesignTokens = {
  background: "#f1f3f5",
  foreground: "#2b3038",
  surface: "#ffffff",
  surfaceForeground: "#2b3038",
  surfaceSecondary: "#e9ecef",
  surfaceSecondaryForeground: "#2b3038",
  surfaceTertiary: "#dee2e6",
  surfaceTertiaryForeground: "#2b3038",
  overlay: "#ffffff",
  overlayForeground: "#2b3038",
  muted: "#6b7280",
  default: "#eceef0",
  defaultForeground: "#2b3038",
  accent: "#f0860f",
  accentForeground: "#3a2706",
  danger: "#e23b2e",
  dangerForeground: "#ffffff",
  warning: "#e2960f",
  warningForeground: "#3a2c06",
  success: "#1f9d52",
  successForeground: "#ffffff",
  separator: "#9aa3ad",
  glassBackground: "rgba(255, 255, 255, 0.85)",
  glassBorder: "rgba(40, 46, 56, 0.12)",
  glassHighlight: "rgba(40, 46, 56, 0.08)",
  glow0: "rgba(240, 134, 15, 0.12)",
  glow1: "rgba(99, 119, 145, 0.1)",
  glow2: "rgba(226, 150, 15, 0.08)",
  mutedForeground: "#6b7280",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(40, 46, 56, 0.1)",
  overlayShadow: "rgba(40, 46, 56, 0.14)",
  fieldShadow: "rgba(40, 46, 56, 0.08)",
  fieldBorder: "rgba(40, 46, 56, 0.16)",
  fieldPlaceholder: "rgba(40, 46, 56, 0.55)",
  fieldBackground: "rgba(40, 46, 56, 0.05)",
  segment: "#ffffff",
  segmentForeground: "#2b3038",
  link: "#f0860f",
  focus: "#f0860f",
  fieldForeground: "#2b3038",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#9aa3ad",
  primary: "#f0860f",
  primaryForeground: "#3a2706",
  secondary: "#eceef0",
  secondaryForeground: "#2b3038",
  backdrop: "rgba(20, 24, 30, 0.5)",
};

/**
 * Base tokens for Dark mode.
 */
export const DARK_BASE_TOKENS: DesignTokens = {
  background: "#1d2128",
  foreground: "#f6f7f8",
  surface: "#262b33",
  surfaceForeground: "#f6f7f8",
  surfaceSecondary: "#2e333c",
  surfaceSecondaryForeground: "#f6f7f8",
  surfaceTertiary: "#373d47",
  surfaceTertiaryForeground: "#f6f7f8",
  overlay: "#2a2f38",
  overlayForeground: "#f6f7f8",
  muted: "#9aa3ad",
  default: "#353b44",
  defaultForeground: "#f6f7f8",
  accent: "#f59a2e",
  accentForeground: "#2a1c06",
  danger: "#ef5446",
  dangerForeground: "#ffffff",
  warning: "#eba61f",
  warningForeground: "#2c2206",
  success: "#34b865",
  successForeground: "#0e2c18",
  separator: "#4a5159",
  glassBackground: "rgba(29, 33, 40, 0.55)",
  glassBorder: "rgba(255, 255, 255, 0.12)",
  glassHighlight: "rgba(255, 255, 255, 0.22)",
  glow0: "rgba(245, 154, 46, 0.42)",
  glow1: "rgba(99, 119, 145, 0.4)",
  glow2: "rgba(235, 166, 31, 0.28)",
  mutedForeground: "#9aa3ad",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.3)",
  overlayShadow: "rgba(0, 0, 0, 0.45)",
  fieldShadow: "rgba(0, 0, 0, 0.25)",
  fieldBorder: "rgba(255, 255, 255, 0.12)",
  fieldPlaceholder: "rgba(255, 255, 255, 0.45)",
  fieldBackground: "rgba(255, 255, 255, 0.04)",
  segment: "#3a414b",
  segmentForeground: "#f6f7f8",
  link: "#f59a2e",
  focus: "#f59a2e",
  fieldForeground: "#f6f7f8",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#4a5159",
  primary: "#f59a2e",
  primaryForeground: "#2a1c06",
  secondary: "#353b44",
  secondaryForeground: "#f6f7f8",
  backdrop: "rgba(0, 0, 0, 0.7)",
};
